import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export interface PageProps {
  centered?: boolean;
}

const S = {
  centered: css`
    max-width: 800px;
    margin: 0 auto;
  `,
};

export const Page = styled.article<PageProps>`
  padding: ${tokens.spacer.x3} ${tokens.spacer.x4} 0;
  ${({ centered }) => centered && S.centered};
`;
